import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/business-communications")({
  head: () => buildRouteHead("/es/servicios/business-communications", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/sobre-qbd", replace: true });
  },
});
